import { useEffect, useState } from "react";
import { INDIA_TIMEZONE_HINTS, INDIA_LANGUAGE_HINTS } from "@/config/pricing";

function detectByDevice() {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const lang = navigator.language;
  return (
    INDIA_TIMEZONE_HINTS.some((hint) => tz.includes(hint)) ||
    INDIA_LANGUAGE_HINTS.some((hint) => lang.includes(hint))
  );
}

export function useLocationPricing() {
  const [isIndianUser, setIsIndianUser] = useState<boolean | null>(null);
  const [locationLoading, setLocationLoading] = useState(true);

  useEffect(() => {
    const detectIndianUser = async () => {
      try {
        // First: use ipinfo for accuracy
        const res = await fetch(
          `https://ipinfo.io/json?token=${import.meta.env.VITE_IPINFO_API_KEY}`
        );
        const data = await res.json();
        if (data.country === "IN") {
          setIsIndianUser(true);
          return;
        }

        // Fallback: use timezone/language detection
        setIsIndianUser(detectByDevice());
      } catch (error) {
        console.error("IP detection failed, falling back:", error);
        setIsIndianUser(detectByDevice());
      } finally {
        setLocationLoading(false);
      }
    };

    detectIndianUser();
  }, []);

  return { isIndianUser, locationLoading };
}
